<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

<p align="center" style="margin-top:20px;">
    <strong>UMOWA ZLECENIE {{ shortNrUmowy() }}</strong>
</p>
<p>
    Zawarta w Łodzi pomiędzy:
</p>
<p><strong>Zleceniodawcą:</strong></p>
<p>
  <strong>Tutore Poland Sp. z o.o.</strong>, z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do
  Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd
  Rejonowy dla Łodzi-Śródmieścia w Łodzi, XX Wydział Krajowego Rejestru Sądowego pod
  nr KRS: 0000670834, NIP: 727-28-12-193, REGON: 366891567, reprezentowaną przez: 
</p>
<p>
  <strong>{{zamawiajacy}}</strong>,
</p>
<p>a</p>
<p>
  <strong>Zleceniobiorcą:</strong>
  <br/>
  Imię i nazwisko: {{imieNazwisko}}
  <br/>
  Pesel: {{pesel}}
  <br/>
  Adres: {{zamieszkany}}
  <br/>
  <br/>

  <p align="center"><strong>Warunki umowy</strong></p>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1 Przedmiot umowy</strong>
</p>
<p style="margin-bottom: 0px;">Zleceniodawca zleca, a Zleceniobiorca podejmuje się wykonywania za wynagrodzeniem na rzecz Zleceniodawcy takich czynności jak:
</p>
<ol>
  <li>wsparcie metodyczne nad jakością prowadzonych zajęć przez osoby prowadzące zajęcia, zwane dalej Nauczycielami;</li>
  <li>prowadzenie wizytacji przeprowadzonych zajęć online (tj. ocena jakości przeprowadzonych zajęć online, uzupełnianie tabeli wizytacyjnych, rozmowa z osobą prowadząca zajęcia online) według harmonogramu szkoły;</li>
  <li>weryfikacja pracy Nauczycieli (dziennika zajęć, realizacji podstawy programowej, materiałów oraz innej dokumentacji przez nich prowadzonej);</li>
  <li>sprawdzenie oraz przygotowanie oceny przeprowadzonych zajęć;</li>
  <li>organizacja spotkań oraz szkoleń dla Nauczycieli i innych osób związanych z daną usługą;</li>
  <li>terminowe wykonywanie wszystkich wytycznych organizacyjnych Zleceniodawcy w terminach przez niego określonych;</li>
  <li>współpraca z osobami wyznaczonymi przez Zleceniodawcę, przy czym Zleceniobiorca zobowiązany jest do regularnego i niezwłocznego (najpóźniej na koniec każdego dnia roboczego) odczytywania wiadomości wysyłanych przez te osoby poprzez pocztę e-mail, wiadomości sms lub poprzez komunikatory internetowe i w razie potrzeby jak najszybszego udzielenia odpowiedzi na informacje, w tym szczególnie:
    <ol type="a">
      <li>przekazywanie niezbędnych informacji w zakresie określonym w danej sytuacji,</li>
      <li>udział w zebraniach, rozmowach wizytacyjnych i ewaluacjach;</li>
    </ol>
  </li>
  <li>współpraca z rodzicami uczniów, w tym szczególnie udzielanie niezbędnych informacji dotyczących usługi (np. przekazywanie prac domowych, sprawdzanie i przekazywanie raportów z postępów uczniów);</li>
  <li>inne zadania i projekty zlecone przez Zleceniodawcę.</li>
</ol>
<p>Celem zapewnienia warunków do wykonania niniejszej umowy, Zleceniodawca zobowiązuje się do udostępnienia wszystkich niezbędnych materiałów dydaktycznych, takich jak panele edukacyjne, grafiki do prezentacji oraz indywidualnego konta w systemie do nauki online. Powyższe nie obejmuje sprzętu elektronicznego (komputer, telefon, sprzęt nagłaśniający, itp.), które Zleceniobiorca zobowiązany jest zorganizować na własny koszt.</p>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 2 Wykonywanie umowy</strong>
</p>
<ol>
  <li>Zleceniobiorca zobowiązuje się wykonywać przedmiot niniejszej umowy z należytą starannością.</li>
  <li>Wykonanie przedmiotu umowy wskazanego w § 1 odbywać się będzie online za pośrednictwem platform udostępnionych przez Zleceniodawcę.</li>
  <li>Łączny wymiar godzin realizowania przedmiotu umowy będzie określony w harmonogramie każdorazowo przez Zleceniodawcę z wyprzedzeniem i podsumowany na koniec każdego miesiąca kalendarzowego.</li>
  <li>Strony dopuszczają zmianę dat i godzin realizowania przedmiotu umowy w harmonogramie wyłącznie za obopólną zgodą.</li>
  <li>Zleceniobiorca będzie wykonywać usługi objęte niniejszą umową w warunkach całkowitej niezależności od Zleceniodawcy. W szczególności Zleceniodawca nie będzie uprawniony do wykonywania wobec Zleceniobiorcy jakichkolwiek praw kierowniczych, nie ingerując w organizację i/lub dyscyplinę pracy Zleceniobiorcy. Wszelkie problemy techniczne lub metodologiczne dotyczące całości powierzonych Zleceniobiorcy czynności będą rozwiązywane przez wspólne porozumienie Stron, z poszanowaniem niezależności działalności zawodowej prowadzonej przez Zleceniobiorcę.</li>
  <li>Zleceniobiorca nie może powierzyć wykonania przedmiotu niniejszej umowy osobie trzeciej.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 3 Obowiązek informacyjny</strong>
</p>
  <ol>
    <li>Zleceniodawca zobowiązany jest dostarczać Zleceniobiorcy wszelkich informacji niezbędnych do realizacji przez niego przedmiotu umowy.
</li>
    <li>Zleceniobiorca zobowiązany jest udzielać Zleceniodawcy potrzebnych informacji o przebiegu realizacji przez niego przedmiotu umowy.</li>
  </ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 4 Absencje i powiadamianie o nich</strong>
</p>
  <ol>
    <li>W przypadku niemożności zrealizowania przedmiotu umowy w terminach określonych w harmonogramie z przyczyn leżących po stronie Zleceniobiorcy zobowiązuje się on do niezwłocznego powiadomienia Zleceniodawcy o zaistniałym fakcie, nie później niż 7 dni przed planowaną nieobecnością. W takim przypadku Zleceniodawca może wyznaczyć osobę, która zastąpi Zleceniobiorcę w wykonaniu zlecenia opisanego w niniejszej umowie.
</li>
    <li>W przypadku nagłej niedyspozycji wynikającej z choroby lub złego stanu zdrowia, które wystąpiło nagle, Zleceniobiorca może nie zachować 7-dniowego okresu powiadomienia o niemożności wykonywania zlecenia. Zleceniobiorca zobowiązuje się niezwłocznie, nie później niż 4 godziny po wystąpieniu zdarzenia, powiadomić o takiej sytuacji Zleceniodawcę.</li>
    <li>W przypadku nagłej niedyspozycji wynikającej z choroby lub złego stanu zdrowia, które wystąpiło nagle, Zleceniobiorca może nie zachować 7-dniowego okresu powiadomienia o niemożności wykonywania zlecenia, jednak zobowiązany jest do poinformowania Zleceniodawcy niezwłocznie po zaistnieniu takiego zdarzenia. Zleceniobiorca potwierdza to, na podstawie e-zwolnienia lekarskiego, które wpłynie na profil Zleceniodawcy w portalu PUE ZUS.</li>
    <li>W przypadku niezrealizowania zlecenia w terminie wynikającym z harmonogramu i nie powiadomienia o tym fakcie Zleceniodawcy z wyprzedzeniem nie mniejszym niż 7 dni przed planowaną nieobecnością, Zleceniodawca może rozwiązać umowę ze skutkiem natychmiastowym bez zachowania okresu wypowiedzenia. W takim przypadku, niezależnie od możliwości wypowiedzenia umowy, Zleceniodawca może ponadto dochodzić kary umownej w wysokości 5 000 zł (słownie: pięć tysięcy złotych) od Zleceniobiorcy za poniesione straty.</li>
    <li>Zleceniodawca może także dochodzić odszkodowania przenoszącego wartość zastrzeżonej kary umownej. Powyższy zapis nie dotyczy sytuacji losowych uniemożliwiających powiadomienie Zleceniodawcy o niemożliwości zrealizowania przedmiotu umowy.</li>
  </ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 5 Czas trwania umowy i okres wypowiedzenia</strong>
</p>
<ol>
  <li>Strony zawierają umowę od dnia {{dataObowiazywaniaUmowy()}} do dnia {{datakon}} r.</li>
  <li>Strony mogą rozwiązać umowę z zachowaniem miesięcznego okresu wypowiedzenia, ze skutkiem prawnym na koniec następnego miesiąca kalendarzowego, po pisemnym przesłaniu informacji o wypowiedzeniu umowy (z zastrzeżeniem ust. 3 niniejszego paragrafu).</li>
  <li>Zleceniodawca ma prawo rozwiązać niniejszą umowę bez zachowania okresu wypowiedzenia w sytuacji braku możliwości powierzenia przedmiotu niniejszej umowy lub jeżeli Zleceniobiorca rażąco sprzeciwia się postanowieniom niniejszej umowy, przez co strony rozumieją w szczególności:
    <ol type="a">
      <li>zachowanie Zleceniobiorcy polegające na niewykonywaniu obowiązków określonych w § 1, pomimo uprzedniego wezwania ze strony Zleceniodawcy do zaniechania naruszeń,</li>
      <li>złamanie przez Zleceniobiorcę zakazu konkurencji,</li>
      <li>ujawnienie przez Zleceniobiorcę Informacji Poufnych,</li>
      <li>wszelkie inne naruszenia niniejszej umowy.</li>
    </ol>
  </li>
  <li>W przypadku rozwiązania umowy Zleceniobiorca zobowiązuje się do zwrotu materiałów udostępnionych na czas trwania umowy przez Zleceniodawcę w terminie do 14 dni od dnia rozwiązania lub wygaśnięcia umowy. W przypadku braku zwrotu materiałów w wyznaczonym terminie Zleceniodawca może nałożyć na Zleceniobiorcę karę finansową o wartości otrzymanych materiałów. Dodatkowo Zleceniobiorca może zostać obciążony kosztami przesyłki.
</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 6 Wynagrodzenie</strong>
  </p>
<ol>
  <li>Z tytułu prawidłowego wykonania czynności wymienionych w § 1 Zleceniobiorca otrzyma wynagrodzenie w wysokości: {{ kwota }} zł brutto (słownie: {{ slownie }} {{ przedmiot === 'Język Angielski' ? 'złotych' : '' }}) za jedną godzinę wykonywanego zlecenia.</li>
  <li>Całkowite miesięczne wynagrodzenie będzie wynikać ze stawki godzinowej wynikającej z ust. 1 niniejszego paragrafu oraz liczby godzin zrealizowanego zlecenia w danym miesiącu, w oparciu o zestawienie, o którym mowa w ust. 4 niniejszego paragrafu.</li>
  <li v-if="typZajec === 'zajęcia hybrydowe' && przedmiot === 'Rysunek'">W przypadku przeprowadzenia zajęć stacjonarnych we wskazanej przez Zleceniodawcę stacjonarnej jednostce wynagrodzenie za jedną lekcję zostanie zwiększone o 10,00 zł brutto (słownie: dziesięć złotych) za godzinę.
W zakresie prowadzenia zajęć obie strony wyrażają zgodę na prowadzenie zajęć w stacjonarnych jednostkach w obrębie: {{ stacjonarneJednostki }}. Zleceniodawca nie ponosi kosztów dojazdu do placówki. Materiały na zajęcia Zleceniobiorca zakupuje we własnym zakresie na fakturę (wystawioną na dane Zleceniodawcy), którą rozlicza z Działem Księgowym Zleceniodawcy.</li>
  <li>Maksymalna liczba godzin wykonywania zlecenia wynosi {{ godzin }} godzin w miesięcznym okresie rozliczeniowym. W przypadku osiągnięcia przez Zleceniobiorcę maksymalnej liczby godzin, jest on zobowiązany do niezwłocznego poinformowania o tym Zleceniodawcę celem ustalenia zasadności przekroczenia limitu godzinowego oraz zasad wynagrodzenia Zleceniobiorcy za godziny wykonane ponad limitem godzin. Zaniechanie poinformowania Zleceniodawcy będzie skutkowało odmową wypłaty wynagrodzenia za godziny przekraczające wyznaczony limit.</li>
  <li>Zleceniobiorca jest zobowiązany do przygotowania i przedłożenia Zleceniodawcy w formie elektronicznej zestawienia liczby godzin przepracowanych w danym miesiącu, wygenerowanego z narzędzi do ewidencjonowania godzin udostępnionego przez Zleceniodawcę, <u>najpóźniej w pierwszym dniu roboczym następnego miesiąca.</u> Zweryfikowane przez Zleceniodawcę zestawienie będzie stanowić podstawę do wypłaty wynagrodzenia Zleceniobiorcy. </li>
  <li>Zleceniodawca może obniżyć o kwotę do 15% wysokości wynagrodzenia brutto za dany miesiąc, w przypadku niestosowania się do zapisów zawartych w umowie w szczególności: nierzetelnego i niedokładnego realizowania przedmiotu umowy, niedotrzymywania podanej dyspozycyjności, nieodpisywania na e-maile oraz nieodbierania telefonów od osób wskazanych do kontaktu przez Zleceniodawcę, nie zachowywania zasad kultury osobistej w kontakcie z osobami wskazanymi przez Zleceniodawcę.</li>
  <li>Wynagrodzenie Zleceniobiorcy będzie płatne z dołu w cyklu miesięcznym do 15-tego każdego miesiąca, przelewem na numer konta bankowego wskazanego przez Zleceniobiorcę.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 7 Premia</strong>
  </p>
<ol>
  <li>Zleceniodawca może przyznać Zleceniobiorcy premię uznaniową w wysokości do 15% wynagrodzenia brutto, której przyznanie jest uzależnione od stopnia realizacji przydzielonych zadań indywidualnych. Zadania indywidualne na kolejny miesiąc będą przedstawiane z odpowiednim wyprzedzeniem.</li>
  <li>Dodatkowo Zleceniodawca może przyznać dodatkową premię uznaniową za inne cele niezwiązane z ust. 1 niniejszego paragrafu.</li>
  <li>Premia nie ma charakteru roszczeniowego, zaś jej przyznanie, jak i określenie jej wysokości należy do swobodnego uznania Zleceniodawcy.</li>
  <li>Wyliczenie i wypłata premii następuje w ciągu 15 dni od zakończenia miesięcznego okresu rozliczeniowego.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 8 Informacje poufne</strong>
</p>
<ol>
  <li>Przez Informacje Poufne strony rozumieją wszelkie informacje przekazane Zleceniobiorcy przez Zleceniodawcę lub uzyskane przez Zleceniobiorcę w inny sposób w związku z wykonywaniem niniejszej umowy, obejmujące informacje techniczne, technologiczne, organizacyjne lub inne informacje posiadające wartość gospodarczą, które dotyczą Zleceniodawcy i jego działalności, a w szczególności materiały dydaktyczne wykorzystywane przez Zleceniodawcę, baza danych kontaktowych do Klientów Zleceniodawcy (w tym także klientów, którzy zakończyli współpracę ze Zleceniodawcą do 12 miesięcy po zakończeniu umowy), systemy komputerowe oraz pozostałe informacje uzyskiwane od Zleceniodawcy w trakcie wykonywania umowy.</li>
  <li>Zleceniobiorca zobowiązuje się, że Informacje Poufne uzyskane w ramach niniejszej umowy będą utrzymywane w tajemnicy przez Zleceniobiorcę i wykorzystywane wyłącznie do wykonania niniejszej umowy. Informacje Poufne nie będą wykorzystywane w innych celach ani nie będą ujawniane, czy udostępniane osobom trzecim, w całości lub w części. Zobowiązanie do zachowania poufności dotyczy Informacji Poufnych uzyskanych przez Zleceniobiorcę od Zleceniodawcy w formie pisemnej oraz ujawnionych Zleceniobiorcy ustnie, wizualnie, elektronicznie lub w inny sposób. Zleceniobiorca zobowiązuje się utrzymywać otrzymane Informacje Poufne w tajemnicy i nie ujawniać ich komukolwiek bez pisemnej zgody Zleceniodawcy.
  <li>Zleceniobiorca, po zakończeniu współpracy Stron, bądź też, przed jej zakończeniem – na każde żądanie Zleceniodawcy - zobowiązany będzie zwrócić Zleceniodawcy w ciągu 3 dni wszelkie Informacje Poufne, wraz z dokumentacją i innymi nośnikami, na których zostały one utrwalone, jak również, kopiami dokumentacji lub nośników zawierających takie Informacje. Zleceniobiorca zobowiązuje się do usunięcia z pamięci komputerów oraz innych urządzeń wszystkich otrzymanych lub wykonanych materiałów w sposób uniemożliwiający ich odtworzenie oraz wykorzystywanie w przyszłości w jakiejkolwiek formie.</li>
  <li>W przypadku naruszenia przez Zleceniobiorcę postanowień ustępów poprzedzających, w szczególności, poprzez niezgodne z tą umową ujawnienie lub udostępnienie materiałów oraz Informacji Poufnych, Zleceniobiorca zobowiązany będzie do zapłaty na rzecz Zleceniodawcy kary umownej w wysokości 5 000,00 zł (słownie: pięć tysięcy złotych) za każde takie naruszenie. Kara taka płatna będzie w terminie 14 dni od daty złożenia przez Zleceniodawcę oświadczenia o obciążeniu Zleceniobiorcy karą umową.</li>
  <li>Jeżeli wysokość szkody lub utraconych korzyści Zleceniodawcy wynikających z naruszenia przez Zleceniobiorcę postanowień niniejszej umowy przewyższać będzie wysokość kary umownej wskazanej w ust. 4 niniejszego paragrafu, Zleceniodawca może dochodzić odszkodowania uzupełniającego na zasadach ogólnych wynikających z Kodeksu cywilnego.</li>
  <li>Za naruszenie zasad opisanych w niniejszej umowie, Zleceniodawca uznaje także każdorazowe wykorzystanie materiałów dydaktycznych Zleceniodawcy do prywatnych celów Zleceniobiorcy oraz do celów nauczania osób, które nie są Klientami Zleceniodawcy.</li>
  <li>Niezależnie od wygaśnięcia czy rozwiązania niniejszej umowy, zobowiązania Zleceniobiorcy zachowania w poufności Informacji Poufnych pozostają w mocy bezterminowo.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 9 Zakaz konkurencji</strong>
</p>
  <ol>
    <li>Za działalność konkurencyjną w rozumieniu niniejszego paragrafu Strony uznają: oferowanie lub świadczenie przez Zleceniobiorcę jakichkolwiek usług edukacyjnych w jakiejkolwiek formie wobec klientów Zleceniodawcy, którzy zawarli umowę ze Zleceniodawcą najpóźniej w dniu wygaśnięcia niniejszej umowy.</li>
  <li>Za działalność konkurencyjną uważa się również:
    <ol type="a">
      <li>świadczenie przez Zleceniobiorcę pracy na rzecz podmiotu prowadzącego działalność konkurencyjną względem Zleceniodawcy; świadczenie przez Zleceniobiorcę usług w oparciu o jakąkolwiek umowę prawa cywilnego na rzecz podmiotu prowadzącego działalność konkurencyjną względem Zleceniodawcy,</li>
      <li>prowadzenie przez Zleceniobiorcę przedsiębiorstwa prowadzącego działalność konkurencyjną względem Zleceniodawcy, także za pośrednictwem osoby trzeciej,</li>
      <li>bycie wspólnikiem spółki prowadzącej działalność konkurencyjną względem Zleceniodawcy,</li>
      <li>zasiadanie przez Zleceniobiorcę w organach podmiotów prowadzących działalność konkurencyjną wobec Zleceniodawcy,</li>
      <li>występowanie w charakterze agenta, pełnomocnika lub prokurenta osób prowadzących działalność konkurencyjną względem Zleceniodawcy.</li>
    </ol>
  </li>
  <li>Zleceniobiorca zobowiązuje się w czasie trwania współpracy opisanej niniejszą umową nie prowadzić działalności konkurencyjnej w trakcie trwania niniejszej umowy względem działalności Zleceniodawcy według definicji przedstawionej w ust. 1 niniejszego paragrafu.</li>
  <li>Jeżeli to Klient, który jest aktualnym Klientem Zleceniodawcy, sam złoży propozycję współpracy Zleceniobiorcy, Zleceniobiorca ma obowiązek poinformowania Klienta o ww. zakazie działalności konkurencyjnej i odmówienia podjęcia współpracy oraz jest zobligowany do poinformowania Zleceniodawcy o zaistniałej sytuacji.</li>
  <li>Zleceniodawca zastrzega sobie prawo do sprawdzenia względem Zleceniobiorcy, czy zapisy niniejszego paragrafu są należycie wykonywane przez Zleceniobiorcę.</li>
  <li>Za każdorazowe złamanie zakazu konkurencji, o którym mowa w niniejszej umowie, Zleceniodawca może naliczyć Zleceniobiorcy karę w wysokości 20 000,00 zł (słownie: dwadzieścia tysięcy złotych). W takim przypadku Zleceniodawca może dochodzić także odszkodowania przenoszącego wartość zastrzeżonej kary umownej.</li>
  </ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 10 Doręczenia i korespondencja, zgoda na wykorzystanie wizerunku, RODO</strong>
</p>
<ol>
  <li>Strony postanawiają, że o ile nie dojdzie do pisemnego powiadomienia o zmianie adresu do korespondencji wszelka korespondencja kierowana na adresy podane w oznaczeniu stron, uważa się za doręczone najpóźniej z datą drugiego awizo.</li>
  <li>Adresy poczty elektronicznej podane są w oznaczeniu stron. Pismo wysłane drogą elektroniczną uważa się za doręczone z chwilą, gdy druga strona miała możliwość zapoznania się z nim.</li>
  <li>Zleceniobiorca wyraża zgodę na wykorzystanie swojego wizerunku, zgodnie z załącznikiem do niniejszej umowy.</li>
  <li>Zleceniobiorca zobowiązany jest do stosowania się do przepisów Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (RODO) oraz Ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (t.j. Dz. U. z 2019 r. poz. 1781 z późn. zm). Zleceniobiorca wyraża zgodę na przetwarzanie jego danych osobowych, zgodnie z klauzulą informacyjną stanowiącą załącznik do niniejszej umowy.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 11 Spory i sąd właściwy</strong>
</p>
<p>Strony oświadczają, że dołożą wszelkich starań by spory wynikłe z niniejszej umowy rozwiązać polubownie. W przypadku sporów, które nie będą mogły zostać rozwiązane polubownie w ciągu 14 dni od daty otrzymania przez drugą stronę pisemnego wezwania do takiego polubownego rozwiązania, zostaną one poddane pod rozstrzygnięcie sądowi właściwemu ze względu na siedzibę Zleceniodawcy.</p>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 12 Kompletność oraz zmiana umowy</strong>
</p>
<ol>
  <li>Niniejsza umowa rozwiązuje i zastępuje wszelkie inne dotychczasowe pisemne lub ustne ustalenia, porozumienia, uzgodnienia i umowy Stron w zakresie objętym jej treścią, które niniejszym tracą moc prawną.</li>
  <li>Strony oświadczają, że poza niniejszą umową nie istnieją między nimi żadne dodatkowe ustalenia czy porozumienia dotyczące przedmiotu niniejszej umowy.</li>
  <li>Wszelkie zmiany niniejszej umowy wymagają formy pisemnej pod rygorem nieważności.</li>
  <li>Rozwiązanie niniejszej umowy wymaga formy pisemnej pod rygorem nieważności.</li>
</ol>
<br><br><br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 13 Klauzula salwatoryjna</strong>
</p>
<p>
Jeżeli którekolwiek z postanowień niniejszej umowy okaże się nieważne w całości lub w części, pozostałe postanowienia pozostają w mocy, Strony zaś zobowiązują się na wniosek którejkolwiek z nich do zastąpienia nieważnych postanowień postanowieniami, których moc prawna i skutek ekonomiczny są najbardziej zbliżone do postanowień zastępowanych.</p>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 14 Prawo właściwe</strong>
</p>
<ol>
  <li>Niniejsza umowa podlega prawu polskiemu.
</li>
  <li>W sprawach nieuregulowanych niniejszą umową zastosowanie mają właściwe przepisy prawa, w szczególności przepisy Kodeksu cywilnego.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 15 Liczba egzemplarzy umowy</strong>
</p>
<p>Niniejsza umowa została sporządzona w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.</p>
<br>

<div>
  <p class="underline">Załączniki:</p>
  <ol>
    <li class="underline">Zgoda na wykorzystanie wizerunku</li>
    <li class="underline">Klauzula informacyjna RODO</li>
    <li class="underline">Upoważnienie do przetwarzania danych osobowych</li>
    <li class="underline">Informacja o monitoringu zajęć on - line</li>
    <li class="underline">Oświadczenie Zleceniobiorcy</li>
    <li class="underline">Ogólne zasady bhp przy pracy administracyjno-biurowej</li>
  </ol>
</div>

<div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
        <span style="margin-left: 0%;">{{zamawiajacy}}</span><br>
        <span style="margin-left: 0%;">Podpis Zleceniodawcy</span>
    </div>
    <div class="right-cointainer">
        {{imieNazwisko}}<br>
        <span style="margin-left: 0%;">Podpis Zleceniobiorcy</span>
    </div>
</div>
<br><br>

 <div style="margin-top:5px;page-break-before: always;">
   <p><strong>Załącznik nr 1. ZGODA NA WYKORZYSTANIE WIZERUNKU</strong></p>
   <p>Niniejszym oświadczam, że udzielam Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440, KRS 0000670834, NIP: 727-28-12-193, REGON: 366891567, (dalej: Tutore Poland Sp. z o.o.) zgody, na nieodpłatne utrwalenie oraz nieograniczone czasowo i terytorialnie wielokrotne wykorzystanie i rozpowszechnianie mojego wizerunku w formie fotografii w związku z wykonywaniem umowy zlecenia w celu umieszczenia jej w firmowej stopce mailowej. Wizerunek będzie wykorzystywany wyłącznie na czas trwania umowy w formie zdjęcia w korespondencji mailowej wysyłanego w imieniu Zleceniodawcy.</p>
   <p>Jak również niniejszym oświadczam, że udzielam Tutore Poland Sp. z o.o. zgody, na nieodpłatne utrwalenie oraz nieograniczone czasowo i terytorialnie wielokrotne wykorzystanie i rozpowszechnianie mojego głosu lub wypowiedzi utrwalonych w trakcie wykonywania niniejszej umowy o świadczenie usług przy użyciu telefonów o połączeniu VoIP (Voice over Internet Protocol).</p>
   <p>Niniejsza  zgoda  obejmuje  następujące  pola  eksploatacji:  wykorzystanie,  utrwalanie, obróbkę  i  powielanie  wykonanych  zdjęć/nagrań,  obrót  egzemplarzami,  na  których  utrwalono mój wizerunek lub głos oraz na zwielokrotnianie wizerunku/głosu wszelkimi dostępnymi technikami i metodami, rozpowszechnianie   oraz   publikowanie,   w   materiałach służących   działalności Tutore Poland w szczególności w materiałach szkoleniowych, edukacyjnych i promocyjnych w dowolnej formie.</p>
   <p>Tutore Poland Sp. z o.o. przysługuje wyłączne prawo decydowania o formie i czasie wykorzystywania mojego wizerunku, głosu, wypowiedzi w całości lub w postaci dowolnych fragmentów. Wizerunek może być użyty do różnego rodzaju form elektronicznego przetwarzania obrazu, kadrowania i kompozycji, bez obowiązku akceptacji produktu końcowego, lecz nie w formach obraźliwych lub ogólnie uznanych za nieetyczne.</p>
   <div style="page-break-before: always;">
  <p><strong>Załącznik nr 2. KLAUZULA INFORMACYJNA</strong></p>
  <p>Klauzule informacyjne z art. 13 RODO</p>
  <p> Zgodnie z art. 13 ust. 1 i 2 rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych) (Dz. Urz. UE L 119 z 04.05.2016, str. 1), dalej „RODO”, informuję, że:</p>
  <p>Administratorem Pani/Pana danych osobowych jest Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440, KRS 0000670834, zwany dalej: „ADO”.</p>
  <p>Może Pan/Pani kontaktować się z ADO pisząc na adres: Tutore Poland Sp. z o.o, ul. Piotrkowska 157A, 90-440, mail kadry@tutore.eu oraz poprzez kontakt z Inspektorem Ochrony Danych na adres e-mail: mlokaj@mlkancelaria.com</p>
  <p>ADO przetwarza dane osobowe w celu:</p>
  <ol type="a">
    <li>nawiązania współpracy - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>zapewnienia kontaktu pomiędzy Stronami (adres  e – mail, nr telefonu) - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>realizacji praw i obowiązków wynikających z umowy o świadczenie usług - Art. 6 ust. 1 lit. b, c, f RODO,</li>
    <li>prowadzenia rejestru korespondencji - Art. 6 ust. 1 lit. c, f RODO,</li>
    <li>ewidencji przebiegu współpracy (w tym realizacja płatności) - Art. 6 ust. 1 lit. b, c RODO,</li>
    <li>dochodzenia roszczeń i praw - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>realizacji obowiązków podatkowych - Art. 6 ust. 1 lit. b, c RODO,</li>
  </ol>
  <br>
  <p>Odbiorcami danych osobowych są podmioty, którym ADO powierzył przetwarzanie danych osobowych, w szczególności: dostawcy usług technicznych i organizacyjnych, dostawcy usług księgowych, kadrowych, prawnych i doradczych, banki (realizacja płatności), organy publiczne w ramach realizacji obowiązków związanych z prowadzeniem działalności gospodarczej przez ADO. </p>
  <p>ADO nie przekazuje danych osobowych poza Europejski Obszar Gospodarczy.</p>
  <p>Dane osobowe przechowywane będą przez okres realizacji umowy, a następnie przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa, w tym w szczególności: dochodzenie roszczeń (okres przedawnienia roszczeń), prowadzenie ksiąg rachunkowych i dokumentacji podatkowej (5 lat od końca roku kalendarzowego, w którym powstał obowiązek podatkowy).</p>
  <p>Osoba, której dane są przetwarzane ma prawo dostępu do swoich danych oraz otrzymania ich kopii, prawo do sprostowania (poprawiania) swoich danych, prawo do usunięcia danych, prawo do cofnięcia zgody, prawo do ograniczenia przetwarzania, prawo do bycia zapomnianym, prawo do sprzeciwu, prawo do przenoszenia danych, prawo do wniesienia skargi do Urzędu Ochrony Danych Osobowych.</p>
  <p>Podanie przez Panią/Pana danych osobowych oraz zgoda na ich przetwarzanie i rozpowszechnianie wizerunku jest dobrowolne, ale stanowi warunek konieczny dla nawiązania współpracy i ewentualnego zawarcia umowy w formie pisemnej oraz realizacji praw i obowiązków przez ADO.</p>
  <p>W ramach działalności ADO nie dochodzi do zautomatyzowanego podejmowania decyzji, w tym profilowania, z wykorzystaniem zebranych danych osobowych.</p>
  <p>Zakres danych podlegający przetwarzaniu: imię i nazwisko, adres mailowy, numer telefonu, wizerunek, PESEL.</p>
  <p style="margin-top: 75px;">{{imieNazwisko}}</p>
  <p>Podpis</p>
  </div>
  </div>

<div style="page-break-before: always;">
  <div class="cointainer" style="margin-top: 60px;">
    <div class="left-cointainer">
      <p><em>Załącznik nr 3</em></p>
    </div>
    <div class="right-cointainer">
      <p style="margin-bottom: 10px; font-size: 14px;">
    Łódź, dnia {{ aktualnaData() }} r.
      </p>
    </div>
</div>
  
  
<p align="center" class="subheading" style="margin-bottom: 10px;">
  <strong>
    Upoważnienie uzupełniające<br>
    do przetwarzania danych osobowych w zbiorze w wersji<br>
    papierowej i elektronicznej
  </strong>
</p>
<p class="p-margin">
  Na podstawie art. 29 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, niniejszym:
</p>
<p class="p-margin">
  z dniem podpisania upoważnienia przez obie strony
</p>
<p class="p-margin">
  upoważniam Pana/Panią {{ imieNazwisko }} Zleceniobiorcę Tutore Poland Sp. z o.o.
</p>
<p class="p-margin">
  realizująca umowę zlecenie poprzez prowadzenie zajęć z przedmiotu {{ przedmiot }} w dziale edukacji
</p>
<p class="p-margin">
  do przetwarzania danych osobowych zawartych w poniżej wymienionych zbiorach danych osobowych:
</p>
  <ol type="a">
    <li>w wersji elektronicznej:
      <ul>
        <li>
          zbiór danych osobowych Klientów: rodziców (opiekunów prawnych) dzieci, młodzieży i dorosłych korzystających z usług oferowanych przez Tutore Poland – imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail,
        </li>
        <li>
          zbiór danych osobowych Klientów: dzieci, młodzieży i dorosłych korzystających z usług oferowanych przez Tutore Poland– imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail.
        </li>
      </ul>
    </li>
  </ol>
<p class="p-margin">
  w zakresie wglądu, wprowadzania, modyfikacji, usuwania i archiwizacji danych osobowych objętych wyżej wymienionymi zbiorami.
</p>
<p class="p-margin">
  Niniejsze  upoważnienie  nie  upoważnia  do  udzielania  dalszych  upoważnień  i  wygasa  z  dniem ustania umowy zlecenia, a ponadto może być w każdym czasie zmienione lub odwołane.
</p>
<p>
  Zobowiązuję Pana/Panią do przetwarzania danych osobowych  zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy - Administratora Danych Osobowych. Zobowiązuję Pana/Panią do przetwarzania danych osobowych  zgodnie z udzielonym upoważnieniem, rozporządzeniem Parlamentu Europejskiego i Rady  (UE)2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych  oraz uchylenia dyrektywy 95/46/WE ( Dz. Urz. UE L 119, s.1) oraz przepisami ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. z 2018 r. poz.1000) i obowiązującymi w Tutore Poland Sp. z o.o..wewnętrznymi regulacjami w sprawie ochrony danych osobowych.
  <br>
  Naruszenie ww. obowiązków  może skutkować  poniesieniem  odpowiedzialności karnej oraz stanowi podstawę do rozwiązania umowy zlecenie.
</p>

<div class="container" style="page-break-before: always;">
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
          <ol>
        <li>Ja niżej podpisany/a oświadczam, iż:
        <ol type="a">
          <li>
            zapoznałem/am się z treścią i zakresem upoważnienia i przyjmuję je do wiadomości,
          </li>
          <li>
            treść upoważnienia jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący,
          </li>
          <li>
            zobowiązuję się do przetwarzania danych osobowych  zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy,
          </li>
          <li>
            zobowiązuję się do przetwarzania danych osobowych  zgodnie z udzielonym upoważnieniem, przepisami Rodo oraz wewnętrznymi procedurami obowiązującymi u Zleceniodawcy, w tym Polityką Prywatności,
          </li>
          <li>
            zobowiązuję się do zachowania w tajemnicy danych osobowych, do których mam lub będę miał dostęp w związku z wykonywaniem obowiązków na rzecz Tutore Poland Sp. z o.o. oraz zachowania w tajemnicy sposobów zabezpieczenia danych osobowych, również po odwołaniu lub zmianie upoważnienia, a także po zakończeniu trwania umowy zlecenie.
          </li>
        </ol>
        </li>
        </ol>
          <div class="right-cointainer" style="float: right; margin-top: 20px;">
        <span style="font-size: 14px;">{{imieNazwisko}}</span>
        <br>
        <span>czytelny podpis Zleceniobiorcy</span>
        </div>
      </td>
    </tr>
  </table>
  </div>

<p class="subheading p-margin" style="text-align: center;">
  {{ zamawiajacy }} 
  <br>
  <strong>w imieniu Administratora</strong>
</p>
<br>
<p>Niniejsze upoważnienie uchylone zostało w dniu rozwiązania umowy zlecenie.</p>
</div>

<div style="page-break-before: always;">
  <p><em>Załącznik nr 4</em></p>
  <p class="subheading" style="margin-bottom: 0px;"><strong>Informacja o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on - line</strong></p>
  <br>
  Informujemy, iż Tutore Poland Sp. z o.o. korzysta z środków technicznych umożliwiających monitoring prowadzonych zajęć on – line oraz nagrywania szkoleń wewnętrznych on - line. Monitoringiem są objęte urządzenia rejestrujące obraz oraz dźwięk, z których korzysta użytkownik w celu realizacji zajęć online tj. platforma Clickmeeting bądź aplikacja Zoom, a w przypadku szkoleń wewnętrznych online aplikacja Zoom. Tutore Poland Sp. z o.o. stosuje monitoring w następujących celach: zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez pracowników/zleceniobiorców, prawidłowości wykonywania powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), a w przypadku szkoleń wewnętrznych on – line w celu zapewnienia możliwości udostępnienia nagrań nowym pracownikom/zleceniobiorcom. Informujemy, iż: system monitoringu audiowizualnego i dźwiękowego zajęć online składa się z systemu rejestrującego platformy Clickmeeting bądź Zoom oraz serwera, na którym są zapisywane zajęcia online, dostęp do zapisu nagrań zajęć online posiadają osoby upoważnione przez Zarząd Tutore Poland Sp. z o.o. tj. Manager Działu Call Center, Dyrektor ds. Zarządzania Procesami, Teamleader Działu Infolinii, osoby, które mają wgląd do zarejestrowanego obrazu mają świadomość odpowiedzialności za ochronę danych osobowych oraz posiadają stosowne upoważnienie wydane przez Administratora danych osobowych. W toku nagrania dochodzi do przetwarzania danych osobowych w postaci głosu, wizerunku oraz imienia i nazwiska pracownika/zleceniobiorcy prowadzącego zajęcia lub szkolenie. Administratorem danych osobowych uzyskanych w ramach monitoringu zajęć on – line i w toku nagrywania szkoleń wewnętrznych on - line jest Tutore Poland Sp. z o.o., który w związku z opisaną powyżej czynnością zamieszcza poniżej wymaganą klauzulę informacyjną dotyczącą przetwarzania danych osobowych.
</div>

<div style="margin-top:40px; page-break-before: always; font-size: 10px;">
  <p align="right" style="font-size: 14px; margin-bottom: 0;">
        Łódź, dnia {{ aktualnaData() }} r.
      </p>
        <p style="font-size: 14px; margin-bottom: 0;">{{imieNazwisko}}</p>
        <p style="font-size: 14px;">Imię i nazwisko Zleceniobiorcy</p>
<p align="center" class="subheading">
  <strong>INFORMACJA O PRZETWARZANIU DANYCH OSOBOWYCH</strong>
</p>
<ol>
  <li>
    Informuję, że Administratorem danych osobowych Pani/Pana jako Zleceniobiorcy jest Tutore Poland Sp. z o.o. z siedzibą przy ul. Piotrkowska 157A, 90-440 Łódź, KRS: 0000670834, NIP: 7272812193, tel. 500 965 135, info@tutore.eu
  </li>
  <li>
    Przedstawiając Pani/Panu niniejszą informację o przetwarzaniu danych osobowych Administrator spełnia obowiązek prawny wynikający z art. 15 ust. 1 Rozporządzenia Parlamentu Europejskiego i  Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w  związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO.
  </li>
  <li>
    Administrator pozyskuje informacje o Pani/Panu w związku z obowiązkiem ustawowym, co jest niezbędne do skutecznej realizacji procesu współpracy. W zakresie danych osobowych nie dotkniętych ustawowym warunkiem niezbędności – ich podanie jest dobrowolne.
  </li>
  <li>
    Pani/Pana dane osobowe przetwarzane są w następujących celach, na następującej podstawie i w następującym okresie:
    <ol type="a">
      <li>
        zawarcia oraz realizacji umowy cywilnoprawnej – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. b, c, f RODO) – przez okres współpracy,
      </li>
      <li>
        wyliczenia i wypłaty wynagrodzenia – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit. b RODO) – przez okres współpracy,
      </li>
      <li>
        potrąceń z wynagrodzenia – w celu realizacji obowiązków w zakresie egzekucji z wynagrodzenia wynikających z kodeksu postępowania cywilnego, ustawy o postępowaniu egzekucyjnym w administracji, ustawy o komornikach sądowych (art. 6 ust. 1 lit. c RODO) – przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa,
      </li>
      <li>
        realizacji obowiązków podatkowych – w celu realizacji obowiązków płatnika podatku dochodowego wynikających z ordynacji podatkowej, ustawy o podatku dochodowym od osób fizycznych i innych przepisów podatkowych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku kalendarzowego,
      </li>
      <li>
        realizacji obowiązków wobec ZUS – w celu realizacji obowiązków płatnika  składek  na  ubezpieczenie społeczne  i  zdrowotne wynikających z ustawy o emeryturach i rentach z Funduszu Ubezpieczeń Społecznych, ustawy o systemie ubezpieczeń społecznych oraz ustawy o świadczeniach opieki zdrowotnej finansowanych ze środków publicznych (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit b RODO) – przez okres 5 lat od końca roku kalendarzowego,
      </li>
      <li>
        realizacji obowiązków księgowych – w celu realizacji obowiązków wynikających z ustawy o rachunkowości, ordynacji podatkowej oraz ustawy o podatku dochodowym od osób prawnych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku rozliczeniowego, w którym nastąpiło zdarzenie,
      </li>
      <li>
        bezpieczeństwa fizycznego budynków, pomieszczeń oraz mienia Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) – przez okres współpracy,
      </li>
      <li>
        zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez Współpracowników za pośrednictwem platformy ClickMeeting lub Zoom, prawidłowości wykonywania powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy) poprzez monitoring i nagrywanie kursów online – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) – Wizerunek i głos Współpracownika będzie przetwarzany przez okres 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych zajęć stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,
      </li>
      <li>
        zapewnienia możliwości udostępnienia nagrań nowym Pracownikom i Współpracownikom nagrywanie szkoleń online prowadzonych za pomocą platformy Zoom – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,
      </li>
      <li>
        zapewnienia najwyższych standardów jakości obsługi klienta, w celu szkoleniowym – umożliwiającym poprawienie jakości obsługi, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), zapewnienia bezpieczeństwa Współpracownikom w przypadku zdarzeń niepożądanych i niebezpiecznych ze strony Klientów (np. groźby karalne) poprzez monitoring rozmów telefonicznych z Klientami Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) - przez okres do 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych rozmów telefonicznych stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,
      </li>
      <li>
        tworzenia fotorelacji z obozów dla dzieci i młodzieży na pendrive dla Klientów, fanpagu facebook i Witrynie internetowej www.musicandmore.pl – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,
      </li>
      <li>
        dochodzenia roszczeń lub obrony przed roszczeniami – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) polegającego na występowaniu w sprawach sądowych – w przypadku toczącego się postępowania przez okres trwania postępowania do czasu jego prawomocnego zakończenia oraz przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa.
      </li>
    </ol>
  </li>
  <li>
    Odbiorcami Pani/Pana danych osobowych będą:
    <ul>
      <li>
        organy administracji publicznej (np. Zakład Ubezpieczeń Społecznych, Urzędy Skarbowe) – na mocy odpowiednich przepisów prawa;
      </li>
      <li>
        zakłady opieki zdrowotnej w celach związanych z medycyną pracy;
      </li>
      <li>
        podmioty zewnętrzne dostarczające i wspierające systemy teleinformatyczne Zleceniodawcy (zarówno ogólną infrastrukturę teleinformatyczną, pocztę elektroniczną, jak i  systemy informatyczne stosowane przez Zleceniodawcę w celu obsługi kadrowo-finansowej lub obiegu dokumentów związanych z zatrudnieniem) – na mocy stosownych umów powierzenia przetwarzania danych osobowych oraz przy zapewnieniu stosowania przez ww. podmioty adekwatnych środków technicznych i organizacyjnych zapewniających ochronę danych,
      </li>
      <li>
        biura księgowe:
      </li>
      <li>
        banki – w celu wypłaty wynagrodzeń i innych świadczeń pieniężnych na rzecz Zleceniodawcy w przypadku ich wypłaty za zgodą Zleceniobiorcy na rachunek bankowy;
      </li>
      <li>
        kontrahenci – w celu umożliwienia kontrahentom (potencjalnym oraz obecnym) kontaktu lub w celu bieżącej realizacji zawartych umów, a związanych z  zajmowanym przez Zleceniobiorcę stanowiskiem pracy; 
      </li>
      <li>
        współpracownicy Zleceniodawcy, którzy świadczą usługi na rzecz Tutore Poland Sp. z o.o., w celu umożliwienia współpracownikom kontaktu ze Zleceniobiorcą,
      </li>
      <li>
        podmioty świadczące dodatkowe usługi dla Zleceniobiorców, wyłącznie w przypadku korzystania przez Zleceniobiorcę z tych usług.
      </li>
      <li>
        instytucje ubezpieczeniowe
      </li>
      <li>
        organizacje administracji zagranicznej w krajach UE, w których realizowana jest umowa (dotyczy realizacji umowy za granicą)
      </li>
      <li>
        podmioty szkoleniowe i realizujące obowiązki BHP (jeśli nie ma komórki BHP u Zleceniodawcy)
      </li>
    </ul>
  </li>
  <li>
    Ma Pani/Pan prawo do:
    <ol type="a">
      <li>
        <strong>dostępu do danych</strong> — uzyskania od Administratora potwierdzenia, czy przetwarzane są Pani/Pana dane osobowe. Jeżeli dane są przetwarzane, jest Pani/Pan uprawniona/y do uzyskania dostępu do nich (art. 15 RODO);
      </li>
      <li>
        <strong>otrzymania kopii danych</strong> — uzyskania kopii danych podlegających przetwarzaniu, przy czym pierwsza kopia jest bezpłatna, a za kolejne kopie właściwy Administrator może nałożyć opłatę w rozsądnej wysokości, wynikającą z kosztów administracyjnych (art. 15 ust. 3 RODO);
      </li>
      <li>
        <strong>sprostowania</strong> — żądania sprostowania danych osobowych, które są nieprawidłowe, lub uzupełnienia niekompletnych danych (art. 16 RODO);
      </li>
      <li>
        <strong>usunięcia danych</strong> — żądania usunięcia danych osobowych, jeżeli Administrator nie ma już podstawy prawnej do ich przetwarzania lub dane nie są już niezbędne do celów przetwarzania (art. 17 RODO);
      </li>
      <li>
        <strong>ograniczenia przetwarzania</strong> — żądania ograniczenia przetwarzania danych osobowych (art. 18 RODO), gdy:
        <ol type="i">
          <li>
            kwestionuje Pani/Pan prawidłowość danych osobowych — na okres pozwalający Administratorowi sprawdzić prawidłowość tych danych,
          </li>
          <li>
            przetwarzanie jest niezgodne z prawem, a sprzeciwia się Pani/Pan ich usunięciu, żądając ograniczenia ich wykorzystywania,
          </li>
          <li>
            Administrator nie potrzebuje już tych danych, ale są one Pani/Panu do ustalenia, dochodzenia lub obrony roszczeń;
          </li>
          <li>
            wniosła Pani/wniósł Pan sprzeciw wobec przetwarzania — do czasu stwierdzenia, czy prawnie uzasadnione podstawy po stronie Administratora są nadrzędne wobec podstaw Pani/Pana sprzeciwu;
          </li>
        </ol>
      </li>
      <li>
        <strong>przenoszenia danych</strong> — otrzymania w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego danych osobowych Pani/Pana dotyczących dostarczonych Administratorowi, oraz żądania przesłania tych danych innemu Administratorowi, jeżeli dane są przetwarzane na podstawie Pani/Pana zgody, lub umowy z Panią/Panem zawartej oraz jeżeli dane są przetwarzane w sposób zautomatyzowany (art. 20 RODO);
      </li>
      <li>
        <strong>sprzeciwu</strong> — wniesienia sprzeciwu wobec przetwarzania danych osobowych w prawnie uzasadnionych celach Administratora, z przyczyn związanych z Pani/Pana szczególną sytuacją, w tym wobec profilowania. Administrator dokonuje oceny istnienia ważnych prawnie uzasadnionych podstaw do przetwarzania, nadrzędnych wobec Pani/Pana interesów, praw i wolności lub podstaw do ustalenia, dochodzenia lub obrony roszczeń. Jeżeli zgodnie z oceną Pani/Pana interesy będą ważniejsze od interesów Administratora, Administrator będzie zobowiązany zaprzestać przetwarzania danych w tych celach (art. 21 RODO);
      </li>
      <li>
        <strong>prawo wniesienia skargi do organu nadzorczego</strong> – Prezesa Urzędu Ochrony Danych Osobowych, gdy uzna Pani/Pan, iż przetwarzanie danych osobowych Pani/Pana dotyczących narusza przepisy. Skargi można składać w formie:
        <ul>
          <li>
            pisemnej na adres: ul. Stawki 2, 00-193 Warszawa,
          </li>
          <li>
            elektronicznie za pośrednictwem platformy ePUAP.
          </li>
        </ul>
      </li>
    </ol>
  </li>
  <li>
    W trakcie przetwarzania danych osobowych nie dochodzi do wyłącznie zautomatyzowanego podejmowania decyzji ani do profilowania, o których mowa w art. 22 ust. 1 i 4 RODO, co oznacza, że żadne decyzje Pani/Pana dotyczące nie będą zapadać automatycznie oraz że nie będą tworzone żadne profile Pani/Pana dotyczące.
  </li>
  <li>
    Ma Pani/Pan obowiązek informowania Zleceniodawcy o wszelkich zmianach dotyczących Pani/Pana danych osobowych, przekazanych Zleceniodawcy zgodnie z Umową.
  </li>
</ol>
</div>

<div style="page-break-before: always;">
  <div class="container">
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
          <ol>
        <li>Ja niżej podpisany/a oświadczam, iż:
        <ol type="a">
          <li>zapoznałem/am się z Informacją o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on - line oraz Klauzulą informacyjną i przyjmuję ją do wiadomości,</li>
          <li>treść Informacji i Klauzuli jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący.</li>
          </ol>
          </li>
          <li>W sposób całkowicie dobrowolny, wyrażam zgodę na przetwarzanie moich danych osobowych w celach wskazanych w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line.</li>
          <li>Zostałem/am poinformowany/a, że moje dane osobowe przetwarzane są na podstawie wyrażonej przeze mnie dobrowolnej zgody oraz, że przysługuje mi prawo do jej cofnięcia w każdym czasie, przy czym cofnięcie zgody wywołuje skutki prawne od momentu jego złożenia i będzie pozostawało bez wpływu na przetwarzanie moich danych osobowych dla celów związanych z realizacją badania przed złożeniem oświadczenia o cofnięciu zgody.</li>
          <li>W trybie art. 81 ust.1 ustawy o prawie autorskim i prawach pokrewnych wyrażam zgodę na rozpowszechnianie mojego wizerunku przez Tutore Poland Sp. z o.o. w celach wskazanych w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line.</li>
          </ol>
          <div style="float: right; margin-top: 20px;">
        <span style="font-size: 14px;">{{imieNazwisko}}</span>
        <br>
        <span>czytelny podpis Zleceniobiorcy</span>
        </div>
      </td>
    </tr>
  </table>
  </div>
  </div>

    <div style="margin-top:5px;page-break-before: always;">
  <p><em>Załącznik nr 5</em></p>
  <p align="center" class="subheading"><strong>Oświadczenie Zleceniobiorcy</strong></p>

  <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
  <tbody>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center; width: 300px;">
  <p class="cell-in-first-table"><span><strong>DANE OSOBOWE</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>DO WYPEŁNIENIA</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Data</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{data}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Imiona i Nazwisko</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{imieNazwisko}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer PESEL</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{pesel}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Seria i numer dowodu osobistego (proszę podać w przypadku braku nr PESEL)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrDowodu}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Obywatelstwo</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{obywatelstwo}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer telefonu</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrTelefonu}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres e-mail</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{email}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres zamieszkania</span><br><span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table bigCell"><span>{{zamieszkany}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres korespondencyjny</span><br><span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{korespondencyjny}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Urząd Skarbowy <br>(zgodny z adresem zamieszkania)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table bigCell"><span>{{urzadSkarbowy}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer rachunku bankowego</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrRachunku}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>OŚWIADCZAM, ŻE:</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>ODPOWIEDZI: „TAK” lub „NIE”<br>(lub opis, jeśli jest wymagany)</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>1. Jestem emerytem</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{emeryt}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>2. Jestem rencistą</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{rencista}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3. Posiadam orzeczenie o stopniu niepełnosprawności</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{orzeczenieNiepelnosprawnosc}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3.1. Jeśli wpisano "TAK", proszę określić orzeczony stopień niepełnosprawności</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{stopienNiepelnosprawnosc.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>4. Jestem uczniem/studentem do 26 roku życia<br>(jeśli wpisano "TAK", proszę pominąć pkt. 5,6,7)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{student}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>5. Wnoszę o dobrowolne ubezpieczenie chorobowe<br>(tylko w przypadku objęcia ubezpieczeniem emerytalnym i rentowym)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{chorobowe.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6. Jestem zatrudniony/a na umowę o pracę lub umowę zlecenie<br>(Jeśli wpisano "TAK", proszę uzupełnić poniższe dane)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{zatrudnionyUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.1. Nazwa i adres pracodawcy</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nazwaUmowaPraca}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.2. Wynagrodzenie z tytułu umowy o pracę/umowy zlecenie<br>jest wyższe bądź równe krajowej płacy minimalnej</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{wynagrodzenieUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7. Podlegam ubezpieczeniu społecznemu z innego tytułu<br>niż umowa o pracę i/lub umowa cywilno-prawna z Tutore Poland Sp. z o.o.</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{ubezpieczenieUmowaPraca}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7.1. W przypadku odpowiedzi: TAK, proszę określić tytuł ubezpieczenia</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{tytulUbezpieczenieUmowaPraca}}</span></p>
  </td>
  </tr>

  <tr>
  <td colspan="2" style="border: 1px solid; background-color: #a4c2f4; text-align: center; font-size: 10px">
  <p class="cell-in-first-table"><span><strong>
  Wypełnienie powyższego oświadczenia oznacza deklarację zgodności wypisanych danych ze stanem prawnym oraz faktycznym,oraz świadomość odpowiedzialności karnej za zeznanie nieprawdy lub zatajenie prawdy.
  <br/>
  Zobowiązuję się do poinformowania Pracodawcy w przypadku zmiany ww. danych w terminie 7 dni od daty zaistnienia zmiany. Wyrażam zgodę na podanie Administratorowi danych osobowych mojego numeru telefonu, adresu e-mail i adresu do korespondencji w Oświadczeniu Zleceniobiorcy, celem wysyłki rocznych deklaracji rozliczeniowych.
  <br/>
  </strong></span></p>
  </td>
  </tr>

  </tbody>
  </table>
  </div>
    
  <div style="margin-top: 5px;page-break-before: always;">
  <p><em><b>Załącznik nr 6</b></em></p>
  <p class="subheading" style="margin-bottom: 0px;"><strong>OGÓLNE ZASADY BHP PRZY PRACY ADMINISTRACYJNO-BIUROWEJ</strong></p>
  <br>
  <p>Bezpieczne warunki pracy są zapewnione, gdy:</p>
  <ul>
    <li>Zapewniona jest dostatecznie duża powierzchnia stanowiska pracy (co najmniej 2m wolnej powierzchni podłogi).</li>
    <li>Jest właściwe oświetlenie (w zależności od charakteru pracy min. 300lx).</li>
    <li>Jest dostateczna wentylacja pomieszczenia (naturalna lub mechaniczna); wilgotność względna powietrza nie powinna być mniejsza niż 40%.</li>
    <li>Jest wystarczające ogrzewanie w okresie jesienno-zimowym (min. +18°C)</li>
    <li>Są dostępne i w dobrym stanie urządzenia higieniczno-sanitarne oraz dobry stan techniczny mebli, sprzętu i innych urządzeń.</li>
  </ul>
  <p>Podstawowe czynności, które należy wykonać przed rozpoczęciem pracy:</p>
  <ul>
    <li>Zaplanować  kolejność wykonywania poszczególnych czynności, przygotować potrzebne dokumenty i programy.</li>
    <li>Ustawić ekran monitora względem źródeł światła tak, aby ograniczyć olśnienie i odbicia światła.</li>
    <li>Sprawdzić stan techniczny mebli, sprzętu, urządzeń, stan oświetlenia stanowiska pracy.</li>
    <li>Zaznajomić się dokładnie z instrukcją obsługi i instrukcją bezpiecznej pracy sprzętu elektrycznego i elektronicznego używanego w trakcie wykonywania pracy (komputer, drukarka, itp.).</li>
    <li>Odpowiednio dla siebie dopasować krzesło i przygotować stanowisko pracy.</li>
  </ul>
  <p>Czynności, które należy wykonywać podczas pracy:</p>
    <ul>
    <li>Utrzymywać ład i porządek na stanowisku pracy.</li>
    <li>Zachowywać ostrożność przy używaniu urządzeń elektrycznych.</li>
  </ul>
  <p>Czynności zabronione:</p>
  <ul>
    <li>Dopuszczenia do użytkowania urządzeń osób nieupoważnionych.</li>
    <li>Otwierania osłon podczas pracy urządzeń.</li>
    <li>Używania niesprawnych bądź uszkodzonych urządzeń, względnie instalacji elektrycznej (np. zniszczona izolacja na przewodach, stłuczone wtyczki lub gniazdka, prowizorycznie połączone przewody). </li>
  </ul>
  <p>Uwagi końcowe:</p>
  <ul>
    <li>
        Przy stałej pracy przy komputerze należy:
        <ul>
            <li>łączyć przemiennie prace związana z obsługą monitora ekranowego z innymi rodzajami prac nie obciążającymi narządu wzroku i wykonywanymi  w innych pozycjach ciała – przy nieprzekraczaniu 1 godziny nieprzerwanej pracy przy obsłudze monitora ekranowego lub</li>
            <li>co najmniej 5-minutową przerwę, wliczaną do czasu pracy, po każdej godzinie pracy przy obsłudze monitora ekranowego.</li>
        </ul>
    </li>
  </ul>
  <p style="margin-top: 30px;">Oświadczam, iż zapoznałem się i akceptuję powyższa zasady bhp przy pracy administracyjno-biurowej.</p>
  <div style="margin-top: 40px; font-size: 10px;">
    <p style="font-size: 14px; margin-bottom: 0;">{{ imieNazwisko }}</p>
    <p style="font-size: 14px;">Podpis Zleceniobiorcy</p>
  </div>
  </div>

  </td></tr>
  </tbody></table>

  </v-container>
</template>

<script>
export default {
  name: 'UmowaMetodyk2023',
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      emeryt: '',
      rencista: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      jedenyTytulDoUbezpieczenia: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      wynagrodzenieUmowaPraca: '',
      ubezpieczenieUmowaPraca: '',
      tytulUbezpieczenieUmowaPraca: '',
      umowaOd: '',
      umowaDo: '',
      urzadSkarbowy: '',
      nrUmowy: '',
      datapocz: '',
      datakon: '',
      kwota: '',
      wypo: '',
      slownie: '',
      kwotapokaz: '',
      slowniepokaz: '',
      godzin: '',
      kowtaplus: '',
      slowniekwotaplus: '',
      shortUmowa: '',
      obywatelstwo: '',
      przedmiot: '',
      typZajec: '',
      stacjonarneJednostki: ''
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    shortNrUmowy () {
      let tab = []
      let shortPosition = ''
      tab = this.nrUmowy.split('/')
      switch(tab[3]) {
        case 'Nauczyciel':
          shortPosition = 'Naucz'
          break;
        case 'Metodyk':
          shortPosition = 'Met'
          break
        case 'TworcaMaterialow':
          shortPosition = 'TMat'
          break
        case 'TworcaMaterialowNauczycielMetodyk':
          shortPosition = 'TMatNauMet'
          break
        case 'TworzenieProgramuNauczania':
          shortPosition = 'TPNau'
          break
        case 'AsystentOrganizacyjny':
          shortPosition = 'AOrg'
          break
        case 'MłodszyAsystentOrganizacyjny':
          shortPosition = 'MAOrg'
          break
        case 'TworzenieMap':
          shortPosition = 'TMapMC'
          break
        default:
          shortPosition = tab[3]
      }
      this.shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/${shortPosition}`
      return this.shortUmowa
    },
    dataObowiazywaniaUmowy () {
      if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
        return 'podpisania umowy przez obie strony'
      } else {
        return `${this.umowaOd} r.`
      }
    },
    aktualnaData() {
      const today = new Date();
      let day = today.getDate();
      if((day+1) <= 10) {
        day = '0' + day
      }
      let month = today.getMonth()+1;
      if ((today.getMonth()+1) < 10) {
        month = '0' + month
      } 
      const todayDate = day+'-'+month+'-'+today.getFullYear()
      return todayDate
    }
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href
          history.replaceState(history.state, '', '/')
          window.print()
          history.replaceState(history.state, '', currentURL)
        }, 300)
      })
    }
  }
}
</script>

<style scoped>

.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}

table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}

th, td {
  border: 1px;
  border-collapse: collapse;
}

.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.cointainer-left {
  width: 20%;
}

.cointainer-right {
  width: 20%;
}

thead {
  display: table-header-group;
}

.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}

.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}

ul.dashed {
  list-style-type: "- ";
  margin: 0;
}

.underline {
  text-decoration: underline;
}

.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}

#oswiadczenie {
  padding: 20px;
}

.p-margin {
  margin-bottom: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaMetodyk2023.vue